export enum MessageTypeEnum {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    CUSTOM_SUCCESS = 'CUSTOM_SUCCESS',
    CUSTOM_ERROR = 'CUSTOM_ERROR',
    CUSTOM_ERROR_API = 'CUSTOM_ERROR_API',
    CUSTOM_ERROR_COLLISION = 'CUSTOM_ERROR_COLLISION'
}
